import Text from '../main/Text';
import { IDay } from '../../interfaces';

function Day({ day, open, close }: IDay) 
{
    function makeTime(hour: string | undefined)
    {
        return hour?.slice(0,2) + ':' + hour?.slice(2);
    }

    return (
        <div style = {{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
            <Text text = {day} lineHeight ='20px'/>
            <Text text = {makeTime(open) +  ' - ' + makeTime(close)} lineHeight='20px' />
        </div>
    )
}

export default Day;